export const EVENT_INFO_REQUEST = "EVENT_INFO_REQUEST"
export const EVENT_INFO_SUCCESS = "EVENT_INFO_SUCCESS"
export const EVENT_INFO_FAILURE = "EVENT_INFO_FAILURE"

export const EVENT_ATTENDEE_PUT_REQUEST = "EVENT_ATTENDEE_PUT_REQUEST"
export const EVENT_ATTENDEE_PUT_SUCCESS = "EVENT_ATTENDEE_PUT_SUCCESS"
export const EVENT_ATTENDEE_PUT_FAILURE = "EVENT_ATTENDEE_PUT_FAILURE"

export const EVENT_COMMENTS_PUT_REQUEST = "EVENT_COMMENTS_PUT_REQUEST"
export const EVENT_COMMENTS_PUT_SUCCESS = "EVENT_COMMENTS_PUT_SUCCESS"
export const EVENT_COMMENTS_PUT_FAILURE = "EVENT_COMMENTS_PUT_FAILURE"